import {
    SuklEPoukazApprovalRuleGridObject,
    SuklEPoukazCodeListItemGridObject,
    SuklEPoukazMedicalDeviceGridObject,
} from '@libs/types/src/list/object-type/sukl-epoukaz-catalog.object';
import { GridInput } from '@it2go/data-grid';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../modules/content/service/gql.service-v2';
import { filterFrag } from '../types/filter.types';
import {
    suklEPoukazApprovalRuleFrag,
    suklEPoukazCodeListItemFrag,
    suklEPoukazMedicalDeviceFrag,
} from '../types/sukl-epoukaz-catalog.types';

@Injectable({ providedIn: 'root' })
export class ListSuklEPoukazCatalogService extends GqlServiceV2 {
    public getListSuklEPoukazMedicalDevices(input: GridInput, frag = suklEPoukazMedicalDeviceFrag) {
        return this.query<SuklEPoukazMedicalDeviceGridObject>(this.queryBody('medicalDevices', frag), { input });
    }

    public getListSuklEPoukazCodeListItems(input: GridInput, frag = suklEPoukazCodeListItemFrag) {
        return this.query<SuklEPoukazCodeListItemGridObject>(this.queryBody('codeListItems', frag), { input });
    }

    public getListSuklEPoukazApprovalRules(input: GridInput, frag = suklEPoukazApprovalRuleFrag) {
        return this.query<SuklEPoukazApprovalRuleGridObject>(this.queryBody('approvalRules', frag), { input });
    }

    private queryBody(field: string, frag: string): string {
        return `
            query($input: GridInput!) {
                suklEPoukazCatalog {
                    ${field}(input: $input) {
                        ${filterFrag}
                        items { ${frag} }
                    }
                }
            }
        `;
    }
}
